import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Button,
  ModalFooter,
  Checkbox,
  SimpleGrid,
  Spacer,
  Switch,
  FormControl,
  FormLabel,
  background,
} from "@chakra-ui/react";
import { connect } from "react-redux";
// import epl from "../eplstyles";
import epl from "../clientstyles/eplstyles"
import edp from "../clientstyles/edpstyles"
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import manageStyle from "../NewPages/Dashboardcomponents/Managestyles.module.css";
// import { Tooltip } from "@chakra-ui/react";

const Styling = (props) => {
  const [stylesList, setStyleList] = useState([]);
  const [tooltip, setTooltip] = useState({ id: "" });
  const [client, setClient] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [selecteddescription, setSelectedDescription] = useState({ name: epl[0]?.name });
  const [searchStyles, setSearchStyles] = useState("")
  // const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    switch (props?.currentClient) {
      case "epl":
        setClient(epl)
        break;
      case "edp":
        setClient(edp)
        break;
      default:
        setClient(epl)
        break;
    }
  }, [props.currentClient])


  const filteredStyles = client
    ? Object.entries(client).filter(([keyName, value]) =>
      keyName.toLowerCase().startsWith(searchStyles.toLowerCase())
    )
    : [];

  useEffect(() => {
    if (Object.keys(client).length > 0) {
      const firstKey = Object.keys(client)[0];

      setSelectedDescription({
        name: firstKey,
        value: client[firstKey],
      });
    }
  }, [props.isOpen]);


  const updateSelectedStyles = function (checked, data) {
    if (checked) {
      setStyleList([...stylesList, data]);
    } else {
      let filtered = stylesList.filter(function (el) {
        return el !== data;
      });
      setStyleList(filtered);
    }
  };
  const navigate = useNavigate()
  const checkAll = (checked) => {
    if (checked) {
      setStyleList([])
      Object.keys(client).map((i) => {
        return setStyleList((prev) => [...prev, i]);
      });
    } else {
      setStyleList([]);
    }
  };

  const handleClick = () => {
    props.editToolAction({}) //clear previous changes or styles
    console.log(isChecked ? "checked" : "not checked");
    console.log(props.isChecked ? "checked" : "not checked");
    console.log("under the check in the handleclick in the styling", props.toolStyles);
    setTimeout(() => {
      if (!isChecked) {
        props.eplStyles(stylesList);
        setStyleList([]);
        props.toolStyles({ key: null, data: null, isChecked });
      }
      else {

        props.toolStyles({ key: props?.currentClient, data: stylesList, isChecked }); //ischecked is true
        setStyleList([]);
        props.editToolRejected() //clear previous rejections
        navigate("#suggestions")
      }
    }, 0)
  };


  useEffect(() => {
    if (props.isChecked) {
      setIsChecked(true)
      setStyleList(props.editToolStyles[props?.currentClient] || [])
    }
    else {
      setIsChecked(false)
    }
  }, [props.isOpen])

  const searchingStyles = (e) => {
    setSearchStyles(e.target.value)
  }

  return (
    <Modal size={"4xl"} onClose={props.onClose} isOpen={props.isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {props.currentClient}
          <Spacer />
          <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
            <Checkbox
              isChecked={stylesList.length === Object.keys(client).length}
              onChange={(e) => {
                checkAll(e.target.checked);
              }}
              style={{ marginTop: "10px" }}
            >
              Select All
            </Checkbox>
            <FormControl style={{ width: "fit-content" }} display="flex" alignItems="center" justifyContent="end">
              <FormLabel style={{ fontSize: "15px", cursor: "pointer" }} htmlFor="interactive" mb="0">
                Interactive mode
              </FormLabel>
              <Switch
                id="interactive"
                isChecked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                colorScheme="blue"
                size="sm"
              />
            </FormControl>
          </div>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {/* {
            client !== null &&
            <SimpleGrid columns={2} spacing={4}>
              {Object.keys(client).map((i) => (
                <div key={i}>
                  <Checkbox
                    className="checkbox"
                    isChecked={stylesList.includes(i)}
                    onChange={(e) => updateSelectedStyles(e.target.checked, i)}
                    key={epl[i]?.name}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        gap: "4px",
                        display: "flex",
                        alignItems: "center",
                        width: "230px",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>{client[i]?.name}</div>
                      <div
                        className="infoicon"
                        onMouseEnter={() => setTooltip({ id: i })}
                        onMouseLeave={() => setTooltip({ id: "" })}
                      >
                        <InfoOutlineIcon />
                      </div>
                      {tooltip.id === i ? (
                        <div
                          style={{
                            position: "absolute",
                            height: "auto",
                            width: "200px",
                            background: "rgba(14,13 , 13, 0.64)",
                            // background: "#faf9f9",
                            backdropFilter: "blur(4px)",
                            right: "-180px",
                            top: "25px",
                            zIndex: "1000",
                            color: "#fff",
                            borderRadius: "5px",
                            padding: "10px",
                          }}
                        >
                          {client[i]?.description}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Checkbox>
                </div>
              ))}
            </SimpleGrid>
          } */}
          <div className={manageStyle.searchContainer}>
            <input type='text' value={searchStyles} onChange={searchingStyles}
              className={manageStyle.searchinput}
            />
            <svg className={manageStyle.searchicon} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
              <path d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z"></path>
            </svg>
          </div>
        </ModalBody>
        <div className={manageStyle.BothSideContainer}>
          <div className={manageStyle.LeftsideContainer}>
            <div className={manageStyle.ProjectstylePreviewContainer}>
              {filteredStyles.map(([i, value]) => (
                <div key={i} className={`${selecteddescription?.name === i && manageStyle.currentDiscription} ${manageStyle.projectStyleNames}`}>
                  <Checkbox
                    className="checkbox"
                    isChecked={stylesList.includes(i)}
                    onChange={(e) => updateSelectedStyles(e.target.checked, i)}
                    key={epl[i]?.name}
                  >
                    <div onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedDescription({ name: i, value: value });

                    }}

                      className={manageStyle.individualstyle}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >

                      <div
                        style={{
                          fontSize: "14px",
                          gap: "4px",
                          display: "flex",
                          alignItems: "center",
                          width: "230px",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>{client[i]?.name}</div>
                        <div>
                          <InfoOutlineIcon />
                        </div>
                      </div>
                    </div>
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
          <div className={manageStyle.RightsideContainer}>
            <div className={manageStyle.ProjectdescriptionViewContainer}>

              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px"
              }}>
                <h1 className={manageStyle.Textcolor}>{selecteddescription?.name}</h1>
              </div>

              <div style={{ color: "#222" }}>
                <h3 className={manageStyle.Textcolor}>Description:</h3>
                <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>{selecteddescription?.value?.description || "No description available"}</p>
                <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>Before:</p>
                {selecteddescription?.value?.beforeImage && (
                  <img
                    src={process.env.PUBLIC_URL + selecteddescription.value.beforeImage}
                    alt="After"
                    style={{ paddingBottom: "10px" }}
                  />
                )}

                <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>After:</p>
                {selecteddescription?.value?.afterImage && (
                  <img
                    src={process.env.PUBLIC_URL + selecteddescription.value.afterImage}
                    alt="After"
                    style={{ paddingBottom: "10px" }}
                  />
                )}
              </div>
            </div>

          </div>
        </div>


        <ModalFooter>
          <Button
            style={{}}
            onClick={() => {
              if (stylesList.length > 0) {
                handleClick(props);
                props.onClose();
              }
            }}
            mx={2}
            bg="var(--btn-bg)"
            color="var(--btn-text)"
            _hover={{ bg: "var(--btn-hover)" }}
          >
            Submit
          </Button>
          <Button onClick={props.onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
const mapStateToProps = (state, ownProps) => ({
  editToolStyles: state.toolStyles.function,
  isChecked: state.toolStyles.isChecked,
})
const mapDispatchToProps = (dispatch) => {
  return {
    eplStyles: (data) => dispatch({ type: "Submit", payload: data }),
    toolStyles: (data) => dispatch({ type: "ToolSubmit", payload: data }),
    editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
    editToolAction: (data) => dispatch({ type: "EDITTOOL", payload: data }),
    // submitAction: (res) => dispatch({ type: "onChange", payload: res }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Styling);
